import level1 from 'src/lotties/streak/bronze_rank_1.json';
import level2 from 'src/lotties/streak/bronze_rank_2.json';
import level3 from 'src/lotties/streak/bronze_rank_3.json';
import level4 from 'src/lotties/streak/bronze_rank_4.json';
import level5 from 'src/lotties/streak/bronze_rank_5.json';
import level6 from 'src/lotties/streak/bronze_rank_6.json';
import level7 from 'src/lotties/streak/silver_rank_1.json';
import level8 from 'src/lotties/streak/silver_rank_2.json';
import level9 from 'src/lotties/streak/silver_rank_3.json';
import level10 from 'src/lotties/streak/silver_rank_4.json';
import level11 from 'src/lotties/streak/silver_rank_5.json';
import level12 from 'src/lotties/streak/silver_rank_6.json';
import level13 from 'src/lotties/streak/gold_rank_1.json';
import level14 from 'src/lotties/streak/gold_rank_2.json';
import level15 from 'src/lotties/streak/gold_rank_3.json';
import level16 from 'src/lotties/streak/gold_rank_4.json';
import level17 from 'src/lotties/streak/gold_rank_5.json';
import level18 from 'src/lotties/streak/gold_rank_6.json';
import level19 from 'src/lotties/streak/attender_rank_1.json';
import level20 from 'src/lotties/streak/attender_rank_2.json';
import level21 from 'src/lotties/streak/attender_rank_3.json';
import level22 from 'src/lotties/streak/attender_rank_4.json';
import level23 from 'src/lotties/streak/attender_rank_5.json';
import level24 from 'src/lotties/streak/attender_rank_6.json';
import lille_text from 'src/lotties/streak/lille_text.json';
import stor_text from 'src/lotties/streak/stor_text.json';

export const Level1 = {
  loop: false,
  autoplay: false,
  animationData: level1,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level2 = {
  loop: false,
  autoplay: false,
  animationData: level2,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level3 = {
  loop: false,
  autoplay: false,
  animationData: level3,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level4 = {
  loop: false,
  autoplay: false,
  animationData: level4,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level5 = {
  loop: false,
  autoplay: false,
  animationData: level5,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level6 = {
  loop: false,
  autoplay: false,
  animationData: level6,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level7 = {
  loop: false,
  autoplay: false,
  animationData: level7,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level8 = {
  loop: false,
  autoplay: false,
  animationData: level8,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level9 = {
  loop: false,
  autoplay: false,
  animationData: level9,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level10 = {
  loop: false,
  autoplay: false,
  animationData: level10,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level11 = {
  loop: false,
  autoplay: false,
  animationData: level11,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level12 = {
  loop: false,
  autoplay: false,
  animationData: level12,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level13 = {
  loop: false,
  autoplay: false,
  animationData: level13,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level14 = {
  loop: false,
  autoplay: false,
  animationData: level14,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level15 = {
  loop: false,
  autoplay: false,
  animationData: level15,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level16 = {
  loop: false,
  autoplay: false,
  animationData: level16,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level17 = {
  loop: false,
  autoplay: false,
  animationData: level17,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level18 = {
  loop: false,
  autoplay: false,
  animationData: level18,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level19 = {
  loop: false,
  autoplay: false,
  animationData: level19,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level20 = {
  loop: false,
  autoplay: false,
  animationData: level20,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level21 = {
  loop: false,
  autoplay: false,
  animationData: level21,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level22 = {
  loop: false,
  autoplay: false,
  animationData: level22,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level23 = {
  loop: false,
  autoplay: false,
  animationData: level23,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Level24 = {
  loop: false,
  autoplay: false,
  animationData: level24,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Stor = {
  loop: false,
  autoplay: false,
  animationData: stor_text,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};

export const Lille = {
  loop: false,
  autoplay: false,
  animationData: lille_text,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
  isClickToPauseDisabled: false,
};